// Recalculate carts created before the automatic offer was activated.
// No quantities, codes, notes or customer data are changed; Shopify returns all prices.
document.addEventListener('DOMContentLoaded', async function () {
  if (!document.querySelector('[data-yn-needs-refresh="true"]')) return;
  let userChangedCart = false;
  const markChanged = (event) => {
    if (event.target.closest('product-form, cart-items, cart-drawer-items')) userChangedCart = true;
  };
  document.addEventListener('submit', markChanged, true);
  document.addEventListener('change', markChanged, true);
  document.addEventListener('click', markChanged, true);
  const sections = ['cart-drawer', 'cart-icon-bubble'];
  const main = document.querySelector('#main-cart-items');
  const footer = document.querySelector('#main-cart-footer');
  if (main) sections.push(main.dataset.id);
  if (footer) sections.push(footer.dataset.id);
  try {
    const response = await fetch(window.routes.cart_update_url, {
      method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({updates: {}, sections, sections_url: window.location.pathname})
    });
    if (!response.ok) return;
    const cart = await response.json();
    if (cart.errors || userChangedCart || !cart.sections) return;
    const parsed = {};
    for (const [key, markup] of Object.entries(cart.sections)) {
      if (markup) parsed[key] = new DOMParser().parseFromString(markup, 'text/html');
    }
    const replaceContents = (target, source) => { if (target && source) target.innerHTML = source.innerHTML; };
    const drawer = parsed['cart-drawer'];
    if (drawer) {
      replaceContents(document.querySelector('#CartDrawer-CartItems'), drawer.querySelector('#CartDrawer-CartItems'));
      replaceContents(document.querySelector('.cart-drawer__footer'), drawer.querySelector('.cart-drawer__footer'));
    }
    replaceContents(document.querySelector('#cart-icon-bubble'), parsed['cart-icon-bubble']?.querySelector('.shopify-section'));
    if (main) replaceContents(main.querySelector('.js-contents'), parsed[main.dataset.id]?.querySelector('.js-contents'));
    if (footer) replaceContents(footer.querySelector('.js-contents'), parsed[footer.dataset.id]?.querySelector('.js-contents'));
  } catch (_) { /* Native checkout can still recalculate the offer if a request fails. */ }
  finally {
    document.removeEventListener('submit', markChanged, true);
    document.removeEventListener('change', markChanged, true);
    document.removeEventListener('click', markChanged, true);
  }
});
